import { Link } from "react-router-dom";
import { Instagram, Twitter, Youtube, MapPin, Lock } from "lucide-react";
import Waveform from "@/components/Waveform";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer className="bg-ink border-t border-border/60 pt-16" data-testid="footer">
      <div className="container-sync">
        <Waveform color="rgb(var(--graphite))" className="mb-14" />
        <div className="grid gap-12 md:grid-cols-5">
          <div className="md:col-span-1">
            <Logo variant="wordmark" size="lg" asLink={false} />
            <p className="mt-4 text-graphite text-sm max-w-xs leading-relaxed">
              Premium apparel built for movement — from marathon mornings to city nights.
            </p>
            <p className="mt-4 flex items-center gap-2 font-mono text-[11px] uppercase tracking-wider text-graphite" data-testid="footer-location">
              <MapPin size={13} className="text-signal" /> Atlanta, Georgia, USA
            </p>
          </div>
          {[
            { title: "Shop", links: [["PULSE Performance", "/shop?collection=pulse"], ["CORE Casual", "/shop?collection=core"], ["Accessories", "/shop?collection=accessories"], ["All", "/shop"]] },
            { title: "Brand", links: [["Our Story", "/story"], ["Track Order", "/track-order"], ["Account", "/account"]] },
            { title: "Support", links: [["FAQ", "/faq"], ["Shipping Policy", "/shipping"], ["Returns & Exchanges", "/returns"], ["Contact", "/contact"]] },
          ].map((col) => (
            <div key={col.title}>
              <h4 className="eyebrow mb-5">{col.title}</h4>
              <ul className="space-y-3">
                {col.links.map(([label, to]) => (
                  <li key={label}>
                    <Link to={to} className="text-chalk/70 hover:text-pulse text-sm transition-colors"
                      data-testid={`footer-link-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}>{label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div>
            <h4 className="eyebrow mb-5">Follow</h4>
            <div className="flex gap-4">
              <a href="https://www.instagram.com/itssyncwear" target="_blank" rel="noopener noreferrer"
                data-testid="footer-instagram" aria-label="Instagram — @itssyncwear"
                className="text-chalk/70 hover:text-signal transition-colors">
                <Instagram size={20} strokeWidth={1.5} />
              </a>
              {[["twitter", Twitter], ["youtube", Youtube]].map(([name, Icon]) => (
                <a key={name} href="#!" className="text-chalk/70 hover:text-signal transition-colors" aria-label={name}>
                  <Icon size={20} strokeWidth={1.5} />
                </a>
              ))}
            </div>
            <h4 className="eyebrow mb-5 mt-8">Contact</h4>
            <a href="mailto:info@thesyncwear.com" data-testid="footer-contact-link"
              className="text-chalk/70 hover:text-signal text-sm transition-colors">info@thesyncwear.com</a>
            <p className="mt-6 flex items-center gap-2 font-mono text-[10px] uppercase tracking-wider text-graphite" data-testid="footer-secure-checkout">
              <Lock size={12} className="text-signal" /> Secure checkout by Stripe
            </p>
          </div>
        </div>
        <div className="flex flex-col sm:flex-row justify-between gap-3 py-8 mt-14 border-t border-border/60">
          <p className="font-mono text-[11px] tracking-[0.2em] text-graphite uppercase">© {new Date().getFullYear()} SYNC — Move with the beat</p>
          <div className="flex gap-6">
            <Link to="/privacy" data-testid="footer-link-privacy"
              className="font-mono text-[11px] tracking-[0.2em] text-graphite uppercase hover:text-chalk transition-colors">Privacy Policy</Link>
            <Link to="/terms" data-testid="footer-link-terms"
              className="font-mono text-[11px] tracking-[0.2em] text-graphite uppercase hover:text-chalk transition-colors">Terms & Conditions</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
